/**
 * Whether the structured "Reason" dropdown is offered, and whether it is required (PRET-2025).
 *
 * Read from `program.configuration.specifyAppointmentReason`. The PO confirmed this one value
 * governs BOTH the participant app and the back office, so these rules mirror the mobile helper
 * (`components/appointments/appointmentReasonConfig.ts`) exactly — keep the two in step.
 *
 * It gates the structured **dropdown** only. "Reason for Appointment" is the free-text `subject`
 * and is unaffected.
 *
 * The back office edits the value as FREE TEXT, so `false` arrives as the STRING `"false"`. Shown
 * only for `true` / `"true"` / `"mandatory"` (trimmed, case-insensitive); everything else —
 * `false`, `"false"`, `"empty"`, blank, absent, unrecognised text — hides it. QA's ruling of
 * 2026-09-15 is the specification, since no AC defines this field.
 */

const ON = new Set(["true", "mandatory"]);

const normalise = (value: unknown): string =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const showsAppointmentReason = (value: unknown): boolean => {
  if (value === true) return true;
  if (value === false) return false;

  return ON.has(normalise(value));
};

/** Only the explicit `"mandatory"`; boolean `true` means shown-and-optional. */
export const appointmentReasonIsMandatory = (value: unknown): boolean =>
  normalise(value) === "mandatory";
